webpackJsonp([253472447427885],{

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formik = __webpack_require__(10);
	
	var _yup = __webpack_require__(13);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _Alert = __webpack_require__(14);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Input = __webpack_require__(9);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormMLS = function (_Component) {
	  _inherits(FormMLS, _Component);
	
	  function FormMLS(props) {
	    _classCallCheck(this, FormMLS);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      formState: null
	    };
	    return _this;
	  }
	
	  FormMLS.prototype.render = function render() {
	    var _this2 = this;
	
	    var formState = this.state.formState;
	    var _props = this.props,
	        classes = _props.classes,
	        className = _props.className;
	
	
	    var valid = function valid(current) {
	      return current.day() !== 0 && current.day() !== 6;
	    };
	
	    var renderDay = function renderDay(props, currentDate, selectedDate) {
	      if (currentDate.month() == (0, _moment2.default)().month()) {
	        if (currentDate.date() < (0, _moment2.default)().date()) {
	          if (props.className == "rdtDay") {
	            props.className = "rdtDay rdtDisabled";
	          }
	        }
	      }
	      if (currentDate.month() < (0, _moment2.default)().month()) {
	        props.className = "rdtDay rdtDisabled";
	      }
	
	      return _react2.default.createElement(
	        "td",
	        props,
	        currentDate.date()
	      );
	    };
	
	    if (formState === "success") {
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            maxWidth: "600px",
	            textAlign: "center",
	            margin: "24px auto"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading3", gutterBottom: true },
	            "Thank YOU"
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading5", gutterTop: true },
	            "We appreciate your interest in Elevate & will follow up with you after we've had an opportunity to explore the information you've provided."
	          )
	        )
	      );
	    } else if (formState === "error") {
	      return _react2.default.createElement(
	        "div",
	        { style: { maxWidth: "400px", margin: "24px auto" } },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "error" },
	          "An error occurred."
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)(classes.root, className) },
	      _react2.default.createElement(_formik.Formik, {
	        initialValues: {
	          firstname: "",
	          lastname: "",
	          company: "",
	          email: "",
	          phone: "",
	          title: "",
	          mls_website: "",
	          mls_state: "",
	          form: "mls_form",
	          list: 0
	        },
	        validationSchema: function validationSchema() {
	          return Yup.object().shape({
	            firstname: Yup.string().required("First name is required"),
	            lastname: Yup.string().required("Last name is required"),
	            company: Yup.string(),
	            email: Yup.string().email("Invalid email address").required("Email is required"),
	            phone: Yup.string().required("Phone is required"),
	            mls_number: Yup.string()
	          });
	        },
	        onSubmit: function onSubmit(values, _ref) {
	          var setSubmitting = _ref.setSubmitting;
	
	          //if (values.meetingdate != undefined) {
	          var meeting_request = "";
	          Object.keys(values).forEach(function (key, index) {
	            // key: the name of the object key
	            // index: the ordinal position of the key within the object
	            if (key == "meetingdate") {
	              if (typeof values.meetingdate.format === "function") {
	                meeting_request = values.meetingdate.format("YYYY-MM-DD") + "T" + values.meetingtime.replace(" (EDT)", "") + "-04:00";
	              }
	            }
	          });
	          var body = _extends({}, values, {
	            utm_campaign: window.utm_tags ? window.utm_tags.campaign : "",
	            utm_source: window.utm_tags ? window.utm_tags.source : "",
	            utm_medium: window.utm_tags ? window.utm_tags.medium : "",
	            utm_term: window.utm_tags ? window.utm_tags.term : "",
	            description: values.mls_state + ", " + values.mls_website
	          });
	          return fetch("https://hooks.zapier.com/hooks/catch/4496703/3uy9gh0/", {
	            method: "POST",
	            body: JSON.stringify(body)
	          }).then(function (response) {
	            return response.json();
	          }).then(function (res) {
	            if (res.status === "success") {
	              _this2.setState({ formState: "success" });
	              dataLayer.push({ event: "form-success" });
	
	              if (window.fbq) {
	                window.fbq("track", "Lead");
	              }
	              if (window.gtag) {
	                window.gtag("event", "conversion", {
	                  send_to: "AW-980447970/2_aHCOnsjo8BEOLlwdMD"
	                });
	              }
	              if (window.ga) {
	                window.ga("send", "event", "form", "form_completed", "dms");
	              }
	            } else {
	              _this2.setState({ formState: "error" });
	            }
	          }).catch(function (err) {
	            _this2.setState({ formState: "error" });
	          });
	        },
	        render: function render(_ref2) {
	          var values = _ref2.values,
	              isSubmitting = _ref2.isSubmitting,
	              handleBlur = _ref2.handleBlur,
	              handleChange = _ref2.handleChange;
	          return _react2.default.createElement(
	            _formik.Form,
	            { noValidate: true },
	            _react2.default.createElement(
	              "div",
	              { style: { marginBottom: "30px" } },
	              _react2.default.createElement(
	                "div",
	                { className: classes.headingLarge },
	                "Interested in joining our MLS partner network?"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  maxWidth: "500px",
	                  marginLeft: "auto",
	                  marginRight: "auto"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: classes.topRow },
	                _react2.default.createElement(_formik.Field, {
	                  id: "firstname",
	                  name: "firstname",
	                  label: "First Name",
	                  component: _Input2.default,
	                  className: classes.field
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "lastname",
	                  name: "lastname",
	                  label: "Last Name",
	                  component: _Input2.default,
	                  className: classes.field
	                })
	              ),
	              _react2.default.createElement(_formik.Field, {
	                id: "title",
	                name: "title",
	                label: "Title",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "email",
	                name: "email",
	                label: "Email",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "phone",
	                name: "phone",
	                label: "Phone",
	                component: _Input2.default,
	                className: classes.field,
	                type: "tel"
	              }),
	              _react2.default.createElement(
	                "div",
	                { className: classes.topRow },
	                _react2.default.createElement(_formik.Field, {
	                  id: "company",
	                  name: "company",
	                  label: "MLS Name",
	                  component: _Input2.default,
	                  className: classes.field
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "mls_state",
	                  name: "mls_state",
	                  label: "State",
	                  component: _Input2.default,
	                  className: classes.field
	                })
	              ),
	              _react2.default.createElement(_formik.Field, {
	                id: "mls_website",
	                name: "mls_website",
	                label: "MLS Website",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "submit",
	                  className: classes.signUpBtn,
	                  disabled: isSubmitting
	                },
	                "Submit"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: "11px" } },
	              "By submitting this form, you are requesting to be contacted by a member of the Elevate Sales Team at the details provided via text, email or call (may involve automated or pre-recorded means). You may revoke this consent through any reasonable means.",
	              _react2.default.createElement("br", null),
	              "Existing subscribers seeking support, please visit the",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://support.tryelevate.com/s/ " },
	                "Elevate Help Center"
	              ),
	              "."
	            )
	          );
	        }
	      })
	    );
	  };
	
	  return FormMLS;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      maxWidth: "700px",
	      margin: "0 auto",
	      textAlign: "center"
	    },
	    link: {
	      color: "inherit"
	    },
	    field: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "50px",
	      fontWeight: "600"
	    },
	    topRow: {
	      display: "flex",
	      flexDirection: "row",
	      justifyContent: "space-between",
	
	      "& > * + *": {
	        marginLeft: "12px"
	      }
	    },
	    headingSmall: {
	      fontSize: "20px",
	      textTransform: "uppercase",
	      fontWeight: "600",
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingLarge: {
	      fontSize: "40px",
	      textTransform: "uppercase",
	      fontWeight: "700",
	      color: "#55c3ba",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingText: {
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "1.4em"
	    },
	    checkfield: {
	      width: "20px",
	      height: "20px",
	      position: "relative",
	      top: "4px",
	      marginLeft: "10px"
	    },
	    signUpBtn: {
	      width: "100%",
	      fontSize: "20px",
	      lineHeight: "26px",
	      fontWeight: "600",
	      color: "#FFF",
	      backgroundColor: theme.colors.secondary,
	      borderRadius: "6px",
	      padding: "12px",
	      marginTop: "30px",
	      marginBottom: "30px",
	      textDecoration: "none"
	    },
	    selectfield: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "40px"
	    },
	    selectlabel: {
	      width: "100%",
	      color: "#888f96",
	      display: "flex",
	      fontSize: "14px",
	      alignItems: "center",
	      lineHeight: "18px",
	      fontWeight: "700",
	      marginBottom: "4px"
	    }
	  };
	})(FormMLS);
	module.exports = exports["default"];

/***/ }),

/***/ 3162:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mls-heat-map.2a9426f3.jpg";

/***/ }),

/***/ 3163:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mls_bg.66fbc1eb.jpg";

/***/ }),

/***/ 1710:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _mls_bg = __webpack_require__(3163);
	
	var _mls_bg2 = _interopRequireDefault(_mls_bg);
	
	var _mlsHeatMap = __webpack_require__(3162);
	
	var _mlsHeatMap2 = _interopRequireDefault(_mlsHeatMap);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _FormMLS = __webpack_require__(1562);
	
	var _FormMLS2 = _interopRequireDefault(_FormMLS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Markets = function Markets(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      data = _ref.data,
	      tags = _ref.tags;
	
	  var postNode = {
	    title: "Elevate MLS Markets - " + _siteConfig2.default.siteTitle
	  };
	  var markets = data.allContentfulMarket.edges;
	  var marketCount = 0;
	  markets.forEach(function (_ref2) {
	    var market = _ref2.node;
	
	    marketCount += market.mlsName.length;
	  });
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Elevate MLS Markets - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "markets", customTitle: true }),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundImage: "url(" + _mls_bg2.default + ")", backgroundSize: "cover", backgroundPosition: "centerTop" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { paddingBottom: "80px", paddingRight: "25px", paddingLeft: "25px", paddingTop: "75px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.centerHeading },
	            _react2.default.createElement(
	              "div",
	              { className: classes.heading, style: { color: "#ffffff" } },
	              "The Power of PARTNERS"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext, style: { color: "#ffffff" } },
	              "Our ever-growing network across the U.S. allows us to service more brokers,",
	              _react2.default.createElement("br", null),
	              "agents & teams than most any other solution out there."
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "50px", paddingBottom: "50px" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.mlsHeatMapContainer },
	          _react2.default.createElement("img", {
	            src: _mlsHeatMap2.default,
	            alt: "MLS Heat Map",
	            title: "MLS Heat Map",
	            className: classes.mlsHeatMap
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.table },
	          _react2.default.createElement(
	            "div",
	            { className: classes.tableThead },
	            _react2.default.createElement(
	              "div",
	              { className: classes.tableTh },
	              "State"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.tableTh },
	              "MLS"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.tableTbody },
	            markets.map(function (_ref3) {
	              var market = _ref3.node;
	
	              return _react2.default.createElement(
	                "div",
	                { key: market.id, className: classes.tableTr },
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.tableTd },
	                  market.state
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.tableTd },
	                  market.mlsName && market.mlsName.map(function (mls, i) {
	                    return i === market.mlsName.length - 1 ? _react2.default.createElement(
	                      "span",
	                      { key: mls, className: classes.mls },
	                      mls
	                    ) : _react2.default.createElement(
	                      "span",
	                      { key: mls },
	                      _react2.default.createElement(
	                        "span",
	                        { className: classes.mls },
	                        mls
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        {
	                          style: {
	                            color: "#64616E",
	                            padding: "0px 10px"
	                          }
	                        },
	                        "|"
	                      )
	                    );
	                  })
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { marginTop: "60px", paddingBottom: "25px" } },
	          _react2.default.createElement(_FormMLS2.default, null)
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _flexContainer, _flexItem, _flexItem2, _flexItem3;
	
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      margin: "auto"
	    },
	
	    top: {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "top"
	    },
	
	    heading: {
	      fontSize: "33px",
	      fontWeight: "700",
	      lineHeight: "40px",
	      letterSpacing: ".14px",
	      color: "#5ac0ba",
	      marginBottom: "12px"
	    },
	
	    subtext: {
	      fontSize: "16px",
	      fontWeight: "300",
	      lineHeight: "24px",
	      color: "#777777"
	    },
	
	    centerHeading: {
	      alignItems: "center",
	      width: "100%",
	      textAlign: "center"
	    },
	
	    Heading2: {
	      fontSize: "20px",
	      fontWeight: "700",
	      lineHeight: "26px",
	      color: "#5ac0ba",
	      letterSpacing: ".14px"
	    },
	
	    landingHeaderStyle: {
	      textAlign: "center"
	    },
	
	    mlsHeatMapContainer: {
	      width: "70%",
	      margin: "16px auto 0 auto"
	    },
	    mlsHeatMap: {
	      width: "100%"
	    },
	
	    buttonLink: {
	      minWidth: "250px",
	      maxWidth: "250px",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      display: "block",
	      letterSpacing: ".25px",
	      backgroundColor: theme.colors.secondary,
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "16px",
	      borderRadius: "4px",
	      margin: "16px auto",
	      marginBottom: "20px"
	    },
	
	    flexContainer: (_flexContainer = {
	      padding: "0",
	      margin: '0',
	
	      display: "-webkit-box"
	    }, _flexContainer["display"] = "-moz-box", _flexContainer["display"] = "-ms-flexbox", _flexContainer["display"] = "-webkit-flex", _flexContainer["display"] = "flex", _flexContainer.flexWrap = "wrap", _flexContainer),
	    flexItem: (_flexItem = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem[theme.breakpoints[900]] = {
	      maxWidth: "50%",
	      width: "50%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem),
	
	    flexItem2: (_flexItem2 = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem2[theme.breakpoints[900]] = {
	      maxWidth: "33%",
	      width: "33%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem2),
	
	    flexItem3: (_flexItem3 = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem3[theme.breakpoints[900]] = {
	      maxWidth: "40%",
	      width: "40%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem3),
	    table: {
	      paddingTop: "62px",
	      width: "100%"
	    },
	    tableThead: {
	      display: "flex",
	      alignItems: "center",
	      width: "100%",
	      background: "#ececec"
	    },
	    tableTh: {
	      minWidth: "120px",
	      padding: "14px",
	      fontSize: "14px",
	      textTransform: "uppercase",
	      fontWeight: "700",
	      color: "#64616E"
	    },
	    tableTbody: {
	      fontSize: "16px"
	    },
	    tableTr: {
	      display: "flex",
	      alignItems: "center",
	      width: "100%",
	      borderBottom: "1px solid rgba(100, 97, 110, .25)"
	    },
	    tableTd: {
	      minWidth: "120px",
	      padding: "24px 14px",
	      fontWeight: "600",
	      maxWidth: "100%",
	      display: "flex",
	      flexWrap: "wrap"
	    },
	    mls: {
	      fontWeight: "600",
	      lineHeight: "1.6",
	      color: theme.colors.primary
	    }
	  };
	})(Markets);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-markets-js-8bcb893b7c5756a04bd4.js